<template>
    <form class="contactUpdate modify modify-contact warn-on-exit">
        <!-- Basic Information -->
        <fieldset>
            <div class="form-body">
                <div class="split-fields">
                    <txt label="first_name" v-model="model.first_name"></txt>
                    <txt label="last_name" v-model="model.last_name"></txt>
                </div>
                <div class="form-group">
                    <label class="control-label">Company</label>
                    <company name="Contact" :create="true" :errorName="model.errorName" v-model="model.company" :min-length="2"></company>
                </div>

                <txt label="email" v-model="model.email"></txt>
                <div class="split-fields">
                    <txt label="phone" v-model="model.phone"></txt>
                    <txt label="mobile" v-model="model.mobile"></txt>
                </div>

                <!-- Tag Panel -->
                <div class="tags">
                    <h3><i class="icon icon-tags pull-left"></i></h3>
                    <fieldset>
                        <div id="form-tag">
                            <input-tag :tags="model.tags" placeholder="+ Add Tags"></input-tag>
                        </div> <!-- .form-body -->
                    </fieldset> <!-- .col-md-10 -->
                </div> <!-- .tags -->

                <div class="form-group">
                    <label class="control-label">Comments</label>
                    <textarea v-model="model.comment" @keyup="commentExpand($event)" class="autoExpand" placeholder="Leave a note"></textarea>
                </div>
            </div><!-- .form-body -->
        </fieldset>
        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store" :disabled="saving">
                <span v-if="!saving"><i class="icon icon-save"></i> Save</span>
                <span v-if="saving"><i class="icon icon-spinner fa-spin"></i> Saving</span>
            </button>
        </div>
    </form>
</template>

<script>
    export default {
        components: {
            'InputTag': require('../../components/InputTag.vue').default,
        },
        props: {
            name: { default: '' },
        },
        data() {
            return {
                saving: false,
                tags: '',
                model: {
                    errorName: 'contactCreate',
                    tags: [],
                    public_id: 0,
                    first_name: '',
                    last_name: '',
                    email: '',
                    comment: '',
                    phone: '',
                    mobile: '',
                    company: {}
                },
                address: {}
            }
        },
        created() {
            this.$eventHub.$on('saving' + this.name, this.updateSaving);
        },
        methods: {
            updateSaving(value) {
                this.saving = value;
            },
            store() {
                let before = this.model;
                this.model = Object.assign({}, this.model, this.address);
                this.$store('/api/contact/store', this);
                this.model = before;
            },
            commentExpand(event){
                let el = event.target;
                setTimeout(function(){
                    el.style.cssText = 'height:auto; padding:0';
                    // for box-sizing other than "content-box" use:
                    // el.style.cssText = '-moz-box-sizing:content-box';
                    el.style.cssText = 'height:' + el.scrollHeight + 'px';
                },0);
            }
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('saving' + this.name, this.updateSaving);
        },
    }

</script>
